import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createFactoryMembershipFailed,
  createFactoryMembershipRequested,
  createFactoryMembershipSucceeded,
  deleteFactoryMembershipFailed,
  deleteFactoryMembershipRequested,
  deleteFactoryMembershipSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createFactoryMembershipRequest(factoryId, localId, data) {
  yield put(
    createFactoryMembershipRequested(localId, {
      ...data,
      factoryId,
    }),
  );

  try {
    const { item } = yield call(request, api.createFactoryMembership, factoryId, data);

    const action = createFactoryMembershipSucceeded(localId, item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createFactoryMembershipFailed(localId, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteFactoryMembershipRequest(id) {
  yield put(deleteFactoryMembershipRequested(id));

  try {
    const { item } = yield call(request, api.deleteFactoryMembership, id);

    const action = deleteFactoryMembershipSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteFactoryMembershipFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
